import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import Spinner from '../Spinner';
import ItemModify from '../Form/ItemModify';

@inject('locationStore', 'locationTypeStore')
@observer
class LocationModify extends Component {

  render() {
    const { locationStore, locationTypeStore, params } = this.props;

    if (locationStore.isLoading) { return <Spinner />; }
    let parentLocationOptions = []

    if (params.id === 'add' || params.locationId === 'add') {
      parentLocationOptions = locationStore.items && locationStore.items.map(item => (
        {
          id: item.id,
          name: `${item.name} (${locationTypeStore.findById(item.type_id).name})`
        }));
    } else {
      const currentItem = locationStore.findById(params.id);
      parentLocationOptions = locationStore.items.reduce((acc, item) => {
        if (+item.id !== +currentItem.id) {
          acc.push({
            id: item.id,
            name: `${item.name} (${locationTypeStore.findById(item.type_id).name})`
          });
        }
        return acc;
      }, []);
    }

    return (
      <ItemModify
        id={params.locationId || params.id}
        title='Location'
        slug={this.props.slug || '/configurations/location/station-location'}
        store={locationStore}
        itemFields={[
          { label: 'Id', key: 'id', type: 'text', readOnly: true, editOnly: true },
          { label: 'Name', key: 'name', type: 'text' },
          { label: 'Description', key: 'description', type: 'text' },
          { label: 'Location Type', key: 'type_id', type: 'select', options: locationTypeStore.items, fields: { label: 'name', value: 'id' } },
          { label: 'Parent Location', key: 'parent_id', type: 'select', options: parentLocationOptions, fields: { label: 'name', value: 'id' } }
        ]}
        params={params}
      />
    );
  }
}

export default LocationModify;



// WEBPACK FOOTER //
// ./src/components/Location/LocationModify.js